module.exports = {"140923100":"上馆镇","140923101":"阳明堡镇","140923102":"峨口镇","140923103":"聂营镇","140923104":"枣林镇","140923106":"雁门关镇","140923107":"峪口镇","140923200":"新高乡","140923202":"上磨坊乡","140923400":"代县居民事务中心"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140923.json
// module id = 437
// module chunks = 0